import React, {useState, useEffect} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ScrollContainer from "react-indiana-drag-scroll";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "xlsx";
import { toLakhs,getBrandOptions } from "../../utils/constants";
function ClientTrackerMonth() {
  const [data, setData] = useState([]);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedType, setSelectedType] = useState('all')
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/monthly/client-tracker-month",
        method: "POST",
        responseType: "json",
        data: {
          newspaper: selectedNewspaper,
          month: selectedMonth,
          type:selectedType,
          category: selectedCategory,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if(res.data.userType !== -1){
          setSelectedType(`${res.data.userType}`)
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      const headers = [
        ["", "W2N Data", "W2N Data", "W2N Data", `${selectedNewspaper} Data`, `${selectedNewspaper} Data`, `${selectedNewspaper} Data`],
        ["", "No. of Clients", "No. of Insertions", "Revenue", "No. of Clients", "No. of Insertions", "Revenue"],
      ];
    
      const rows = [
        ["W2N Total", 
          (+data.onlyW2N?.brand_count || 0) + (+data.bothW2N?.brand_count || 0),
          (+data.onlyW2N?.total_insertions || 0) + (+data.bothW2N?.total_insertions || 0),
          (+data.onlyW2N?.total_revenue || 0) + (+data.bothW2N?.total_revenue || 0),
          "", "", ""
        ],
        ["Exclusive W2N, No Eenadu", 
          data.onlyW2N?.brand_count || 0, 
          data.onlyW2N?.total_insertions || 0, 
          data.onlyW2N?.total_revenue || 0, 
          "", "", ""
        ],
        ["Exclusive W2N and Eenadu", 
          data.bothW2N?.brand_count || 0,
          data.bothW2N?.total_insertions || 0,
          data.bothW2N?.total_revenue || 0,
          data.bothPapers?.brand_count || 0,
          data.bothPapers?.total_insertions || 0,
          data.bothPapers?.total_revenue || 0
        ],
        ["Gap in Insertions with " + selectedNewspaper, "", "", "", "", data.bothPapers?.total_insertions - data.bothW2N?.total_insertions, data.bothPapers?.total_revenue - data.bothW2N?.total_revenue],
        ["Known Missings", "", "", "", "", data.knownData?.insertions, data.knownData?.known_spent],
        ["Unknown Missings", "", "", "", "", data.unknownData?.insertions, data.unknownData?.unknown_spent],
        [`Only ${selectedNewspaper}, no W2N`, "", "", "", data.onlyPaper?.brand_count || 0, data.onlyPaper?.total_insertions || 0, data.onlyPaper?.total_revenue || 0],
        ["Gap in Clients & Insertions", "", "", "", data.bothPapers?.brand_count - data.onlyPaper?.brand_count, data.bothPapers?.total_insertions - data.onlyPaper?.total_insertions, data.bothPapers?.total_revenue - data.onlyPaper?.total_revenue],
        ["No of missing clients met physically during the month", "", "", "", data.missedCount?.clients, "", ""],
        ["Known missings", "", "", "", data.knownDataPaper?.clients, data.knownDataPaper?.insertions, data.knownDataPaper?.known_spent],
        ["Unknown missings", "", "", "", data.unknownDataPaper?.clients, data.unknownDataPaper?.insertions, data.unknownDataPaper?.unknown_spent],
        [`${selectedNewspaper} Total`, "","","",
          (+data.onlyPaper?.brand_count || 0 )+ (+data.bothPapers?.brand_count || 0),
         (+data.onlyPaper?.total_insertions || 0) + (+data.bothPapers?.total_insertions || 0),
          (+data.onlyPaper?.total_revenue || 0) + (+data.bothPapers?.total_revenue || 0)
        ],
      ];
    
      const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "client tracker month");
      XLSX.writeFile(workbook, `ClientTrackerMonth.xlsx`);
    
    } catch (error) {
      console.error(error, "client tracker month");
    }
    finally{
      setDownloadLoader(false);
    }
      
  };
  const fetchCategories = async () => {
    try {
      let res = await API({
        url: "/plansummary/categories",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setCategories(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchNewspapers();
    fetchCategories();
  }, []);

  const handleMonthChange = (date) => {
    setSelectedMonth(date);
  };

  useEffect(() => {
    fetchData();
  }, [selectedNewspaper, selectedMonth,selectedType,selectedCategory]);
  return <>
      <div className="flex gap-3 justify-between">
        <h5>Clinet Tracker Month</h5>
        <aside className="flex gap-3 items-center">
        <SlSelect size="small" value={selectedType} label="Team"  onSlChange={(e) => {setSelectedType(e.target.value)}}>
      {data?.userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(data?.userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        <SlSelect size="small" value={selectedCategory} label="Category" onSlChange={(e) => {setSelectedCategory(e.target.value)}}>
          <SlOption value='all'>All</SlOption>
          {categories.map((type) => (
            <SlOption key={type.category_id} value={type.category_id}>{type.category_name}</SlOption>
          ))}
        </SlSelect>
          <SlSelect
            label="Newspaper"
            size="small"
            value={selectedNewspaper}
            onSlChange={(e) => setSelectedNewspaper(e.target.value)}
          >
            {newspapers.map((paper) => (
              <SlOption value={paper.name}>{paper.name}</SlOption>
            ))}
          </SlSelect>
          <div className="clientwiserevenue-datepicker max-w-[200px] ">
            <label className="form-label">Select Month</label>
            <DatePicker
              selected={selectedMonth}
              onChange={handleMonthChange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="dateChooser border h-5 rounded-md"
            />
          </div>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
        </aside>
      </div>
      <ScrollContainer>
        <table className="table table-bordered mt-2">
          <thead>
            <tr>
              <th rowSpan={2}></th>
              <th colSpan={3}>W2N Data</th>
              <th colSpan={3}>{selectedNewspaper} Data</th>
            </tr>
            <tr>
              <th>No.of Clients</th>
              <th>No.of Insertions</th>
              <th>No.of Revenue</th>
              <th>No.of Clients</th>
              <th>No.of Insertions</th>
              <th>No.of Revenue</th>
            </tr>
          </thead>
          {!loader && Object.keys(data)?.length > 0 ? (
            <tbody>
              <tr>
                <th>W2N Total</th>
                <td>{(+data.onlyW2N?.brand_count || 0 )+ (+data.bothW2N?.brand_count || 0)}</td>
                <td>{(+data.onlyW2N?.total_insertions || 0 )+ (+data.bothW2N?.total_insertions || 0)}</td>
                <td>{toLakhs((+data.onlyW2N?.total_revenue || 0) + (+data.bothW2N?.total_revenue || 0))}</td>
                <td colSpan={3} rowSpan={2} className="!bg-gray-200"></td>
              </tr>
              <tr>
                <th>Exclusive W2N, No Eenadu</th>
                <td>{data.onlyW2N?.brand_count || 0}</td>
                <td>{data.onlyW2N?.total_insertions || 0}</td>
                <td>{toLakhs(data.onlyW2N?.total_revenue || 0)}</td>
              </tr>
              <tr>
                <th>Exclusive W2N and Eenadu</th>
                <td>{data.bothW2N?.brand_count || 0}</td>
                <td>{data.bothW2N?.total_insertions || 0}</td>
                <td>{toLakhs(data.bothW2N?.total_revenue || 0)}</td>
                <td>{data.bothPapers?.brand_count || 0}</td>
                <td>{data.bothPapers?.total_insertions || 0}</td>
                <td>{toLakhs(data.bothPapers?.total_revenue || 0)}</td>
              </tr>
              <tr>
                <td>Gap in Insertions with {selectedNewspaper}</td>
                <td colSpan={4} rowSpan={3} className="!bg-gray-200"></td>
                <td>{data.bothPapers?.total_insertions - data.bothW2N?.total_insertions}</td>
                <td>{toLakhs(data.bothPapers?.total_revenue - data.bothW2N?.total_revenue)}</td>
              </tr>
              <tr>
                <td>Known Missings</td>
                <td>{data.knownData?.insertions}</td>
                <td>{toLakhs(data.knownData?.known_spent)}</td>
              </tr>
              <tr>
                <td>Unknown Missings</td>
                <td>{data.unknownData?.insertions}</td>
                <td>{toLakhs(data.unknownData?.unknown_spent)}</td>
              </tr>
              <tr>
                <th>Only {selectedNewspaper}, no W2N</th>
                <td rowSpan={6} colSpan={3} className="!bg-gray-200"></td>
                <td>{data.onlyPaper?.brand_count || 0}</td>
                <td>{data.onlyPaper?.total_insertions || 0}</td>
                <td>{toLakhs(data.onlyPaper?.total_revenue || 0)}</td>
              </tr>
              <tr>
                <td>Gap in Clients & Insertions</td>
                <td>{data.bothPapers?.brand_count  - data.onlyPaper?.brand_count}</td>
                <td>{data.bothPapers?.total_insertions - data.onlyPaper?.total_insertions}</td>
                <td>{toLakhs(data.bothPapers?.total_revenue - data.onlyPaper?.total_revenue)}</td>
              </tr>
              <tr>
                <td>No of missing clients met physically during the month</td>
                <td>{data.missedCount?.clients}</td>
                <td colSpan={2} className="!bg-gray-200"></td>
              </tr>
              <tr>
                <td>Known missings </td>
                <td>{data.knownDataPaper?.clients}</td>
                <td>{data.knownDataPaper?.insertions}</td>
                <td>{toLakhs(data.knownDataPaper?.known_spent)}</td>
              </tr>
              <tr>
                <td>UnKnown missings </td>
                <td>{data.unknownDataPaper?.clients}</td>
                <td>{data.unknownDataPaper?.insertions}</td>
                <td>{toLakhs(data.unknownDataPaper?.unknown_spent)}</td>
              </tr>
              <tr>
                <th>Eenadu Total</th>
                <td>{(+data.onlyPaper?.brand_count || 0) + (+data.bothPapers?.brand_count || 0)}</td>
                <td>{(+data.onlyPaper?.total_insertions || 0) + (+data.bothPapers?.total_insertions || 0)}</td>
                <td>{toLakhs((+data.onlyPaper?.total_revenue || 0) + (+data.bothPapers?.total_revenue || 0))}</td>
              </tr>
            </tbody>
          ) : loader ? (
            <TableSkelton colspan={7} />
          ) : (
            <NoDataFound colspan={7} />
          )}
        </table>
      </ScrollContainer>
  </>;
}

export default ClientTrackerMonth;
